<div class="flex flex-col gap-10 video-grid">
    <mat-card class="top_shortcuts_video">
        <div class="box-container" *ngFor="let video of videos">
            <a [href]="'https://www.youtube.com/watch?v=' + video.id" target="_blank" style="text-decoration: none; color: inherit;">
                <div class="flex justify-center">
                    <img [src]="getThumbnailUrl(video.id)" alt="YouTube video thumbnail" width="160" />
                </div>
                <div class="box-text">{{ video.title }}</div>
                <div class="box-text2">{{ video.description }}</div>
            </a>
        </div>
    </mat-card>
  </div>